module.exports = __webpack_public_path__ + "img/icon-form-password.af013cad.svg";